import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MemberService } from "app/member/member.service";
import { RestService } from "app/webservice/rest.service";
import { Route, ActivatedRoute } from "@angular/router";
import * as $ from 'jquery';
import { ToastsManager } from 'ng2-toastr';
import { GridMetadataService } from 'app/clearwave-grid/grid.metadata.service';
import { ModalDirective } from "ngx-bootstrap";
import { PlatformLocation } from '@angular/common';
import { environment } from "environments/environment";
import { LookupService } from 'app/webservice/lookup.service';
import { Console } from '@angular/core/src/console';

@Component({
  selector: 'app-member',
  templateUrl: './member.component.html',
  styleUrls: ['./member.component.css']
})
export class MemberComponent implements OnInit {

  @ViewChild('assetRenewalModal') public assetRenewalModal: ModalDirective;
  
  public selectedBarcode = '';
  public serviceStackUrl;
  
  public memberInfo = {
    FirstName: '',
    LastName: '',
    BarcodeId: '',
    DepositYN: false,
    FullName: '',
    Email: '',
    Phones: [
      { Number: '', IsPrimary: true, lkpPhoneTypeOid: 0 }, 
      { Number: '', IsPrimary: false, lkpPhoneTypeOid: 0 }
    ],
    EmailOptOut: false,
    Identifier: '',
    IsActive: true,
    lkpGenderOid: 0,
    Gender: '',
    Note: '',
    Salutation: '',
    Addresses: [
      { Street: '', City: '', State: '', Zip: '', lkpAddressTypeOid: 0, IsPrimary: true },
      { Street: '', City: '', State: '', Zip: '', lkpAddressTypeOid: 0, IsPrimary: false }
    ]
  }

  @ViewChild('scannerInput') scannerInput;
  @ViewChild('checkOutModal') checkOutModal;
  @ViewChild('notes') notes;

  public checkout = [];
  public memberEdit = false;
  public MemberCheckoutHistory;
  public MemberCurrentlyCheckedOut;

  constructor(
    private _memberService: MemberService, 
    private _restService: RestService, 
    private route: ActivatedRoute,
    private _toast: ToastsManager,
    private _lookup: LookupService,
    private _gridMetadataService: GridMetadataService,
    private _elementRef : ElementRef,
    platformLocation: PlatformLocation
  ) {        
    
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this.MemberCurrentlyCheckedOut = this._gridMetadataService.describe('MemberCurrentlyCheckedOut', null);
    this.MemberCurrentlyCheckedOut.forceFitColumns = true;
    this.MemberCurrentlyCheckedOut.height = -475;
    this.MemberCurrentlyCheckedOut.completeGridEditDisabled = true;
    this.MemberCurrentlyCheckedOut.disableRest = true;
    this.MemberCurrentlyCheckedOut.title = 'Currently Checked Out';
    this.MemberCurrentlyCheckedOut.onBtnClick = this.renewItems.bind(this);

    this.MemberCheckoutHistory = this._gridMetadataService.describe('MemberCheckoutHistory', null);
    this.MemberCheckoutHistory.forceFitColumns = true;
    this.MemberCheckoutHistory.height = -475;
    this.MemberCheckoutHistory.completeGridEditDisabled = true;
    this.MemberCheckoutHistory.disableRest = true;

    this.lookUpMember();
  }

  ngOnInit() {
  }

  remove(scan) {
    console.log(scan);
    // let foundItem = this.checkout.find(item => item.Oid === scan.Oid);
    // console.log(foundItem);
    let foundItem = this.checkout.indexOf(scan);
    this.checkout.splice(foundItem, 1);
  }

  validatePhone(phone) {
    this.memberInfo.Phones[0].Number = this._memberService.formatPhone(phone);
  }

  validateAltPhone(altPhone) {
    this.memberInfo.Phones[1].Number = this._memberService.formatPhone(altPhone);
  }

  saveProfile() {
    console.log(this.memberInfo);
   this._memberService.AddEditMember(this.memberInfo).then(res => {
      if (res && res.Success) {
        // success
        console.log(res);
        this._toast.success('Member Updated');
        this.memberInfo = res.Member;
        this.memberEdit = false;
      } else {
        // error
        this._toast.error('Failed to update member');
      }
    });
  }

  editProfile(){
    this.memberEdit = true;
  }

  checkOut() {
    console.log("check out");
    this.checkOutModal.show();
    setTimeout(() => {
      $('#scannerInput').focus();
    }, 500);
  }

  renewItems(e, args, row) {
    console.log(row); 
    this.selectedBarcode = row.Items[0].BarcodeId; 
    this.assetRenewalModal.show();
  }

  confirmRenewMedia() {
    console.log(this.selectedBarcode);
    let url = this.serviceStackUrl + 'Asset-CheckIn';
    let renewalObject = {"Barcode":this.selectedBarcode, "IsRenewal":true};
    this._restService.post(url, renewalObject).then(response => {
      if (response.Success) {
        this._toast.success('Renewal(s) Successful!');
        this.assetRenewalModal.hide();
      } else {
        if (response.Errors && response.Errors.length) {
          this._toast.error(response.Errors[0].Message);
          this.assetRenewalModal.hide();
        }
      }
    })
  }

  cancel() {
    this.memberEdit = false;
  }

  findAsset(e) {
    console.log('find asset');
    e.preventDefault();
    let barcode = this.scannerInput.nativeElement.value;
    let url = this.serviceStackUrl + "Asset-GetAssetByBarcode";
    let barcodeObject = {"BarcodeID":barcode};
    this._restService.post(url, barcodeObject).then(response => {
      if (response.Data) {
        this.checkout.push(response.Data);
      } else if (response.ErrorCount > 0) {
        let errors = "<ul>";
        for (let error of response.Errors) {
          errors += "<li>" + error.Message + "</li>";
        }
        errors += "</ul>";
        this._toast.error(errors, null,{enableHTML: true});
      }

      setTimeout(() => {
        $('#scannerInput').val('');
      }, 100);
      // get asset object of found asset, and add it to a checkout array
    })
  }

  lookUpMember() {
    let url = this.serviceStackUrl + "Member-GetMemberWithCheckOutHistoryByOid";
    let memberObject = {"Oid":this.route.snapshot.params['Oid']};
    this._restService.post(url, memberObject).then(response => {
      this.memberInfo = response.Data;
      console.log(this.memberInfo);
      if (this.memberInfo['CheckOutHistory'] && this.memberInfo['CheckOutHistory'].length) {
        this.MemberCheckoutHistory.title = 'Check Out History - ' + this.memberInfo['CheckOutHistory'].length + ' entries';
        if (typeof this.MemberCheckoutHistory.setData === "function") {
          this.MemberCheckoutHistory.setData(this.memberInfo['CheckOutHistory']);
        } else {
          this.MemberCheckoutHistory.data = this.memberInfo['CheckOutHistory'];
        }
      }

      if (this.memberInfo['CurrentlyCheckedOut'] && this.memberInfo['CurrentlyCheckedOut'].length) {
        this.MemberCurrentlyCheckedOut.title = 'Currently Checked Out - ' + this.memberInfo['CurrentlyCheckedOut'].length + ' entries';
        console.log(this.memberInfo['CurrentlyCheckedOut']);
        if (typeof this.MemberCurrentlyCheckedOut.setData === "function") {
          this.MemberCurrentlyCheckedOut.setData(this.memberInfo['CurrentlyCheckedOut']);
        } else {
          this.MemberCurrentlyCheckedOut.data = this.memberInfo['CurrentlyCheckedOut'];
        }
      }
    })
  }

  completeCheckout() {
    console.log('Completeing checkout');
    console.log(this.checkout);
    let oids = [];
    for (let item of this.checkout) {
      oids.push(item.Oid);
    }
    let url = this.serviceStackUrl + "Asset-CheckOut";
    let checkoutObject = {"EntityOid":this.route.snapshot.params['Oid'],"AssetOids":oids, "Note":this.notes.nativeElement.value};
    this._restService.post(url, checkoutObject).then(response => {
      console.log(response)
      this._toast.success('success')
      this.checkOutModal.hide();
      this.lookUpMember();
    })
  }

}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/member/member.component.ts